import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faCircleInfo,
  faCheckCircle,
  faTimesCircle,
  faRocket,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const AlertBanner = ({ title = "Announcement", message, isVisible, onClose }) => {
  if (!isVisible) return null;

  const lower = title.toLowerCase();

  // Auto theme detection
  let theme = {
    bg: "bg-blue-100",
    border: "border-blue-500",
    text: "text-blue-700",
    icon: faCircleInfo,
  };

  if (lower.includes("error") || lower.includes("failed") || lower.includes("danger")) {
    theme = {
      bg: "bg-red-100",
      border: "border-red-500",
      text: "text-red-700",
      icon: faTimesCircle,
    };
  } else if (
    lower.includes("warning") ||
    lower.includes("alert") ||
    lower.includes("caution")
  ) {
    theme = {
      bg: "bg-yellow-100",
      border: "border-yellow-500",
      text: "text-yellow-700",
      icon: faTriangleExclamation,
    };
  } else if (
    lower.includes("success") ||
    lower.includes("ok") ||
    lower.includes("done") ||
    lower.includes("welcome")
  ) {
    theme = {
      bg: "bg-green-100",
      border: "border-green-500",
      text: "text-green-700",
      icon: faCheckCircle,
    };
  } else if (
    lower.includes("update") ||
    lower.includes("info") ||
    lower.includes("announcement")
  ) {
    theme = {
      bg: "bg-blue-100",
      border: "border-blue-500",
      text: "text-blue-700",
      icon: faCircleInfo,
    };
  }

  // Special Launch / Version 2.0 banners
  if (lower.includes("access system 2.0") || lower.includes("launch") || lower.includes("new version")) {
    theme = {
      bg: "bg-purple-100",
      border: "border-purple-500",
      text: "text-purple-700",
      icon: faRocket,
    };
  }

  return (
    <div
      className={`${theme.bg} ${theme.border} border-l-4 ${theme.text} p-4 flex justify-between items-center`}
      role="alert"
    >
      <div className="flex items-center">
        <FontAwesomeIcon icon={theme.icon} className="mr-2" />
        <span>
          <strong>{title}:</strong> {message}
        </span>
      </div>

      <button
        onClick={onClose}
        aria-label="Close"
        className={`${theme.text} hover:opacity-70`}
      >
        <FontAwesomeIcon icon={faTimes} className="h-5 w-5" />
      </button>
    </div>
  );
};

export default AlertBanner;
